 <script>
  import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import appConfig from "@/app.config";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
 
export default {
  mixins: [Api, Sabit], 
  page: {
    title: "Anket Oluştur",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Loader,
    Layout,
    PageHeader,  },
  data() {
    return {
      title: this.$t("AnktAyarlar.Title"),
      items: [ 
        {
          text: this.$t("AnktAyarlar.Title"),
          active: true,
        },
      ],
      FormData: [],
      FormJson: [],
     
    
    };
  },
  methods: { 
    Get() {},
     
  },
  created() {
    
  },
};
</script>
<style >
.dropdown-menu.show{
  overflow-y: scroll !important;
    height: 200px !important;
}
</style>
<template>  
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" /> 

<div class="row"> 
    <div  class="col-6">
        <div class="card">
            <div class="card-body"> 
              

              <h3>{{$t("AnktAyarlar.AddEdit.Baslik")}}</h3>
    </div>   </div>   </div>

    <div  class="col-6">
        <div class="card">
            <div class="card-body"> 
<h3>{{$t("AnktAyarlar.Table.Baslik")}}</h3>
<p>{{$t("AnktAyarlar.Table.Aciklama")}}</p>
               
    </div>   </div>   </div>
</div>
    </Layout>
  </Loader>
</template>